// Only a successful read action may update these opt-in message lists.
export function setIncomingMessageListReadState(id, read, root = document) {
    const messageId = String(id || '');
    if (!/^[1-9]\d*$/.test(messageId) || !root || !root.querySelectorAll) return;

    root.querySelectorAll(`[data-message-list-row="${messageId}"][data-message-list-incoming="true"]`).forEach(row => {
        row.setAttribute('data-message-list-unread', read ? 'false' : 'true');
        row.classList.toggle('font-semibold', !read);
        row.classList.toggle('font-normal', read);
        row.querySelectorAll('[data-message-list-unread-dot]').forEach(dot => { dot.hidden = read; });
        row.querySelectorAll('[data-message-list-read-status]').forEach(status => {
            const label = read ? 'Read' : 'Unread';
            status.setAttribute('data-message-list-read-status', label);
            status.textContent = label;
            status.setAttribute('aria-label', read ? 'Message has been read' : 'Message has not been read');
            if (status.hasAttribute('data-admin2026-client-account-widget-communication-read-status') || status.hasAttribute('data-admin2026-client-account-activity-timeline-read-status')) {
                ['data-admin2026-client-account-widget-communication-read-status', 'data-admin2026-client-account-activity-timeline-read-status'].forEach(attribute => {
                    if (status.hasAttribute(attribute)) status.setAttribute(attribute, label);
                });
                status.className = 'inline-flex shrink-0 items-center rounded-full px-1.5 py-0.5 text-[9px] font-semibold leading-none '
                    + (read ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-200'
                        : 'bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-200');
            }
        });
    });
}

export function markIncomingMessageListRead(id, root = document) {
    setIncomingMessageListReadState(id, true, root);
}

export function syncConfirmedMessageListReads(source, root = document) {
    if (!source || !source.head) return;
    source.head.querySelectorAll('meta[data-message-confirmed-read]').forEach(marker => {
        markIncomingMessageListRead(marker.getAttribute('data-message-confirmed-read'), root);
    });
}
